<template>
  <div class="network-diagram-node-cables-container">
    <div class="flex-horizontal" style="width: fit-content">
      <network-diagram-cable
        v-if="nrCablesIn > 0"
        :cable-data="nodeData.cablesin[0]"
        :hasPreviousSibling="hasPreviousSibling"
        :hasNextSibling="hasNextSibling"
      />
      <network-diagram-node :node-type="nodeType" :node-data="nodeData" />
    </div>

    <div>
      <network-diagram-node-and-cables
        v-for="(node, key, index) in nodeData.children"
        :key="key"
        :node-type="getNodeType(node)"
        :node-data="node"
        :hasPreviousSibling="hasAPreviousSibling(index)"
        :hasNextSibling="hasANextSibling(index, nodeData.children)"
      />
    </div>
  </div>
</template>

<script>
import NetworkDiagramCable from "./NetworkDiagramCable";
import NetworkDiagramNode from "./NetworkDiagramNode";
import _ from "lodash";

export default {
  name: "NetworkDiagramNodeAndCables",

  components: { NetworkDiagramNode, NetworkDiagramCable },

  props: {
    /**
     * Type of node to be represented.
     * */
    nodeType: {
      type: String,
      required: true
    },

    /**
     * Network diagram data of the selected Technical Local or closure.
     */
    nodeData: {
      type: Object,
      required: true
    },

    /**
     * If the current node has siblings being represented before/above.
     */
    hasPreviousSibling: {
      type: Boolean
    },

    /**
     * If the current node has siblings being represented after/below.
     */
    hasNextSibling: {
      type: Boolean
    }
  },

  computed: {
    /**
     * Counts the number of cables entering the current node.
     * @returns {number}
     */
    nrCablesIn() {
      return this.nodeData.cablesin.length;
    }
  },

  methods: {
    /**
     * Determines the type of a given node.
     * @param {object} data - network diagram data of the given node
     * @returns {string|undefined} the name of the node type or undefined in case of an invalid node.
     */
    getNodeType(data) {
      if (data.type === "TechnicalLocal") {
        return data.tl_technical_site_logical_type;
      } else if (data.type === "Closure") {
        return data.cl_logical_type === "DN"
          ? "DropClosure"
          : data.type;
      } else return undefined;
    },

    /**
     * Checks if the current node has siblings being represented before/above.
     * @param {number} index - index of the current node in the list of children from the parent node.
     * @returns {boolean} true the given node is not the first child, false otherwise.
     */
    hasAPreviousSibling(index) {
      return index > 0;
    },

    /**
     * Checks if the current node has siblings being represented after/below.
     * @param {number} index - index of the current node in the list of children from the parent node.
     * @param {number} total - total number of children of the parent node.
     * @returns {boolean} true the given node is not the last child, false otherwise.
     */
    hasANextSibling(index, total) {
      let max = _.keys(total).length - 1;
      return index < max;
    }
  }
};
</script>

<style scoped>
.network-diagram-node-cables-container {
  display: flex;
  flex-direction: row;
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/NetworkDiagram/NetworkDiagramNodeAndCables.vue